import React, { Component } from 'react'
import Grid from './layout/grid'
import './fishboneChart.css'
import Cause from './layout/cause'

const INITIAL_STATE = {
    causes: undefined,
    effect: undefined,
    index: 0,
    selectedCauses: undefined,
    onSelectedCausesExcedded: undefined,
}

export default class FishboneChart extends Component {
    constructor(props) {
        super(props)
        this.state = INITIAL_STATE

        this.onSelectCause = this.onSelectCause.bind(this)
    }

    componentWillMount() { 
        const data = this.props.data

        const totalCauses = this.props.totalCauses
        const selectedCauses = this.props.selectedCauses
        const onSelectedCausesExcedded = this.props.onSelectCause

        if(data) {
            const effect = Object.keys(data)[this.state.index]            
            this.setState({
                causes: data[effect],
                effect,
                selectedCauses: selectedCauses,
                totalCauses: totalCauses,
                onSelectedCausesExcedded: onSelectedCausesExcedded
            })
        }        
    }

    componentDidUpdate(prevProps, prevState) {
        if (prevState.selectedCauses !== undefined && this.props.selectedCauses !== undefined && JSON.stringify(prevState.selectedCauses) !== JSON.stringify(this.props.selectedCauses)) {

            this.setState(prevState => ({
                ...prevState,
                selectedCauses: this.props.selectedCauses,
                totalCauses: this.props.selectedCauses.length,
            }))
        }
    }

    componentWillReceiveProps(nextProps) {
        if(this.props.data !== nextProps.data) {
            const data = nextProps.data
            const effect = Object.keys(data)[this.state.index]
            this.setState({causes: data[effect], effect})
        }
    }

    render() {
        if (!this.state.causes) {
            return <React.Fragment></React.Fragment>
        }

        return (
            <Grid cols={this.props.cols}>
                <div className="fishboneChart h-100">
                    {this.getCauses()}
                    {this.getEffect()}
                    {this.getLegend()}
                </div>
            </Grid>
        )
    }

    getTopCauses(causes) {
        const categories = Object.keys(causes)

        const middle = parseInt(categories.length / 2)
        const topArray = categories.slice(0, middle)

        const color = this.getColor(this.state.index)
        const topCauses = topArray.map((category, index) => {
            return (
                <div key={`top_causes_${category}_${index}`} className="causeContent">
                    <div className={`cause top ${color}_ ${color}Border`}>
                        {category}
                    </div>
                    <div className="causeAndLine">
                        {this.getRootCauses(causes[category])}
                        <div className={`diagonalLine ${color}TopBottom`}/>
                    </div>
                </div>
            )
        })

        return (<div className="causesGroup">{topCauses}</div>)
    }

    onSelectCause(isSelected, causeId, causeList, onSelectedCauses) {
        let limitExcedded = false;
        
        if (isSelected) {
            if (causeList.length < 3) {
                causeList.push(causeId);
            }
            else {
                limitExcedded = true;
            }
        }
        else {
            causeList = causeList.filter(x => x !== causeId)
        }

        if (limitExcedded === false) {
            this.setState(prevState => ({
                ...prevState,
                selectedCauses: causeList
            }))
        }

        onSelectedCauses(limitExcedded, causeList)
    }

    getRootCauses(rootCauses) {
        const causes = rootCauses.map((rootCause, index) => {
            let causeId = parseInt(rootCause.split('[#]')[0]);
            let causeText = rootCause.split('[#]')[1];
            let isSelected = this.state.selectedCauses.find(x => x === causeId) !== undefined;

            return (<div key={index}><Cause
                inputParam_RootCause={{id: causeId, text: causeText}}
                inputParam_IsPreSelected={isSelected}
                inputParam_Index={index}
                inputParam_OnSelectCause={this.onSelectCause}
                inputParam_SelectedCauses={this.state.selectedCauses}
                inputParam_SelectedCausesExcedded={this.state.onSelectedCausesExcedded}
            /></div>)
        })

        return (<div className="rootCauses">{causes}</div>)
    }

    getBottomCauses(causes) {
        const categories = Object.keys(causes)

        const middle = parseInt(categories.length / 2)
        const bottomArray = categories.slice(middle)

        const color = this.getColor(this.state.index)

        const bottomCauses = bottomArray.map((category, index) => {
            return (
                <div key={`bottom_causes_${category}_${index}`}
                    className="causeContent">
                    <div className="causeAndLine">
                        {this.getRootCauses(causes[category])}
                        <div className={`diagonalLine ${color}BottomTop`}/>
                    </div>
                    <div className={`cause bottom ${color}_ ${color}Border`}>
                        {category}
                    </div>
                </div>
            )
        })

        return (<div className="causesGroup">{bottomCauses}</div>)
    }

    getCauses() {
        const causes = this.state.causes
        const color = this.getColor(this.state.index)
        return (
            <div className="causes">
                {this.getTopCauses(causes)}
                <div className={`lineEffect ${color}Border`} />
                {this.getBottomCauses(causes)}
            </div>
        )
    }

    getEffect() {        
        const color = this.getColor(this.state.index)
        return (
            <div className={`effect left ${color}_ ${color}Border`}>
                <div className={`effectValue`}>
                    <div className="ms-2 me-2">
                        {this.state.effect.split('[#]')[0]}
                        <div className='text-center'>
                            {this.state.effect.split('[#]')[1]}
                        </div>
                    </div>
                </div>
            </div>
        )
    }

    selectDataset(index) {
        const data = this.props.data
        if(data) {
            const effect = Object.keys(data)[index]            
            this.setState({causes: data[effect], effect, index})
        }
    }

    getLegend() {        
        const labels = Object.keys(this.props.data)

        if(labels.length <= 1) {
            return
        }

        const labelsDivs = labels.map((label, index) => {
            const labelClass = index === this.state.index ? 'label_' : 'labelLineThrough'
            const color = this.getColor(index)
            return (
                <div key={`labels_${label}_${index}`} className="legendLabel" onClick={() => this.selectDataset(index)}>
                    <div className={`labelSquare legend all ${color}_dark ${color}Border`} />
                    <div className={labelClass}>{label}</div>
                </div>
            )
        })

        return (
            <div className="legend">
                {labelsDivs}
            </div>
        )
    }

    getColor(index) {
        const colors = [
            'blue',
            'pink',
            'gray',
            'green',            
            'blue_two',            
            'orange',
            'black',            
            'purple'
        ]
    
        if (index >= colors.length) {
            index -= colors.length
        }

        return colors[index]
    }
}